import { render, staticRenderFns } from "./AttentionOrg.vue?vue&type=template&id=4fbc8450&scoped=true"
import script from "./AttentionOrg.vue?vue&type=script&lang=js"
export * from "./AttentionOrg.vue?vue&type=script&lang=js"
import style0 from "./AttentionOrg.vue?vue&type=style&index=0&id=4fbc8450&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc8450",
  null
  
)

export default component.exports